<template>
  <div class="product-list-edit" >
    <md-card>
      <md-card-header>
        <div class="md-title" v-if="productList._id">{{ productList.name }}</div>
        <translate tag="div" class="md-title" v-else>Add New Product List</translate>
        <translate tag="div" class="md-caption">Set basic information here</translate>
      </md-card-header>

      <md-card-content>
        <form novalidate @submit.stop.prevent="submit">

          <md-layout md-gutter="16">
            <md-layout>
              <md-input-container :class="{'md-input-invalid': !validName(productList.name) && nameDirty }">
                <md-icon>announcement</md-icon>
                <translate tag="label">Name</translate>
                <md-input id="plist-name-input" @input.native="nameDirty = true" type="text" v-model="productList.name" :value="productList.name" required></md-input>
                <span class="md-error"><translate>Name must be filled</translate></span>
              </md-input-container>
            </md-layout>
            <md-layout>
              <md-input-container :class="{'md-input-invalid': !validCustomId(productList.customId) && customIdDirty }">
                <md-icon>label</md-icon>
                <translate tag="label">ID</translate>
                <md-input id="plist-id-input" @input.native="customIdDirty = true" type="text" v-model="productList.customId" :value="productList.customId" required></md-input>
                <span class="md-error"><translate>ID must be filled</translate></span>
              </md-input-container>
            </md-layout>
          </md-layout>

          <product-selector id="product-selector" :products="products" :prodAvailable="allProducts" :order="false" @addItem="addItem" @removeItem="removeItem"></product-selector>

        </form>
      </md-card-content>

      <md-card-actions>
        <md-button @click.native="cancelForm()"><translate>Cancel</translate></md-button>
        <md-button id="submit-product-list" class="md-raised md-primary" @click.native="submit()"><translate>Save</translate></md-button>
      </md-card-actions>

      <md-snackbar md-position="bottom center" ref="snackbar" :md-duration="4000">
        <translate>The specified Product List name already exists</translate>
        <md-button @click.native="$refs.snackbar.close()"><translate>Close</translate></md-button>
      </md-snackbar>
    </md-card>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import ProductCard from '../products/Card'
import ProductSelector from '../../common/Selector'

export default {
  name: 'product-list-form',
  data () {
    return {
      nameDirty: false,
      customIdDirty: false,
      products: []
    }
  },
  props: [ 'productList' ],
  async created () {
    if (this.productList._id !== undefined) { // fetch the latest version of productList from the server
      await this.$store.dispatch('fetchOneProductList', this.productList._id)
      this.products = this.productList.products
    }
  },
  computed: {
    ...mapGetters([
      'allProducts',
      'allProductLists'
    ])
  },
  methods: {
    ...mapMutations([
      'productListCancelEdit'
    ]),
    ...mapActions([
      'saveProductList',
      'fetchProducts'
    ]),
    nameExists (name) {
      return this.allProductLists.some((prodList) => {
        return prodList.name === name && prodList._id !== this.productList._id
      })
    },
    async submit () {
      this.nameDirty = true
      this.customIdDirty = true
      if (this.validName(this.productList.name) && this.validCustomId(this.productList.customId)) {
        if (this.nameExists(this.productList.name)) {
          this.$refs.snackbar.open()
        } else {
          // we want to save only id and price of each product into product list
          this.productList.products = this.products.map((prod) => {
            return {
              'id': prod.id,
              'price': prod.price
            }
          })
          await this.saveProductList()
          this.$router.push({ name: 'tab-3' })
        }
      }
    },
    cancelForm () {
      this.$router.push({ name: 'tab-3' })
      this.productListCancelEdit()
    },
    validName (name) {
      return name !== ''
    },
    validCustomId (customId) { // TODO validate customId
      return customId !== ''
    },
    // emited events from child 'Product Selector' component because child can't directly modify its props variables
    addItem (item) {
      this.products.push(item)
    },
    removeItem (item) {
      this.products = this.products.filter((prod) => {
        return prod.id !== item.id
      })
    }
  },
  components: {
    ProductCard,
    ProductSelector
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/product-lists/Form.vue